export const ARTICLE_BLOCK_CLASSNAME = 'article__block';

export const QUOTE_HIGHLIGHT_TOOLTIP_ID = 'quote-highlight-tooltip';
